import { Box, Card, CardContent, Typography } from '@material-ui/core';
import React from 'react';
import styles from './SGSMiniCard.module.scss';

type Props = {
    title: string;
    className?: string;
    variant?: 'elevation' | 'outlined';
};

const SGSMiniCard: React.FC<Props> = ({ title, className, variant = 'outlined', children }) => {
    return (
        <Card classes={{ root: styles.root }} className={className} variant={variant}>
            <CardContent>
                <Box>
                    <Typography variant="h3">{title}</Typography>
                    <div className={styles.underline} />
                </Box>
                <Box className="mt-3">{children}</Box>
            </CardContent>
        </Card>
    );
};

export default SGSMiniCard;
